import { useEffect, useState } from "react";
import MobileBottomMenu from "../../Components/MobileBottomMenu";
import MobileLeftSection from "../../Components/MobileLeftSection";
import MobileHeaderSection from "../../Components/MobileHeaderSection";
import { IoCopyOutline } from "react-icons/io5";
import { GET_MONTH_YEAR } from "../../Model/HomeModel";
import { mockTestDetails } from "../../Action/mockTestAction";
import { useDispatch } from "react-redux";
import Lock from "../../Components/Lock";
import { useNavigate } from "react-router-dom";

export default function MobileAcademy({
  detGurully,
  TypeOfTest,
  MockTestRec,
  mockDesc,
}) {
  const [SideOpener, setSideOpner] = useState(false);
  const [Copy, setCopy] = useState(false);
  const [SelectDetails, setSelectDetails] = useState(
    MockTestRec && MockTestRec?.length ? MockTestRec[0] : {}
  );
  const OpenSideMenu = (e) => {
    setSideOpner(!SideOpener);
  };
 
  const dispatch = useDispatch();

  useEffect(()=>{
    if( MockTestRec && MockTestRec?.length){
      setSelectDetails(MockTestRec[0]?._id )
          dispatch(mockTestDetails(MockTestRec[0]?._id));
    }

  },[MockTestRec,dispatch])

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="Mobile_View_css">
        <div
          onClick={OpenSideMenu}
          className={SideOpener ? "menu-overlay active" : "menu-overlay"}
          id="menuOverlay"
        ></div>
        <MobileLeftSection SideOpener={SideOpener} />
        <div className="main-content">
          <MobileHeaderSection Page="Academy" OpenSideMenu={OpenSideMenu} />
          <div className="page-content Live_class" id="materialsPage">
            {/* <!-- Materials Header --> */}
            {detGurully && TypeOfTest === "Gurully" ? (
              <div className="content">
                <div className="calendar-header">
                  <h3>Practice Test</h3>
                </div>
                <div className="classes-list">
                  <div className="class-card">
                    <div className="card-header">
                      <div className="class-info">
                        <div className="instructor-info">
                          <span
                            className="instructor-name"
                            style={{ position: "relative" }}
                          >
                            UserId: {detGurully?.UserId}{" "}
                            <span
                              onClick={() => {
                                navigator.clipboard
                                  .writeText(detGurully?.UserId)
                                  .then(() => {
                                    setCopy(true);
                                    setTimeout(() => {
                                      setCopy(false);
                                    }, 500);
                                  })
                                  .catch((err) => {
                                    console.error("Failed to copy text: ", err);
                                  });
                              }}
                              style={{ marginLeft: "8px", cursor: "pointer" }}
                            >
                              <IoCopyOutline />
                            </span>
                            {Copy ? (
                              <span
                                style={{
                                  position: "absolute",
                                  right: "0px",
                                  top: "55px",
                                  fontSize: "10px",
                                  background: "#0b3eff",
                                  color: "white",
                                  padding: "0px 4px",
                                  borderRadius: "2px",
                                }}
                              >
                                copied
                              </span>
                            ) : (
                              ""
                            )}
                          </span>
                        </div>

                        <div className="instructor-info">
                          <span className="instructor-name">
                            Password: {detGurully?.Password}{" "}
                            <span
                              onClick={() => {
                                navigator.clipboard
                                  .writeText(detGurully?.Password)
                                  .then(() => {
                                    setCopy(true);
                                    setTimeout(() => {
                                      setCopy(false);
                                    }, 500);
                                  })
                                  .catch((err) => {
                                    console.error("Failed to copy text: ", err);
                                  });
                              }}
                              style={{ marginLeft: "8px", cursor: "pointer" }}
                            >
                              <IoCopyOutline />
                            </span>
                          </span>
                        </div>
                      </div>
                      <span className="status-badge">Online</span>
                    </div>

                    <div className="card-divider"></div>

                    <div className="datetime-section">
                      <div className="datetime-item">
                        <svg
                          className="datetime-icon"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                        >
                          <rect
                            x="3"
                            y="4"
                            width="18"
                            height="18"
                            rx="2"
                            ry="2"
                          ></rect>
                          <line x1="16" y1="2" x2="16" y2="6"></line>
                          <line x1="8" y1="2" x2="8" y2="6"></line>
                          <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                        <div className="datetime-content">
                          <span className="datetime-label">Valid From</span>
                          <span className="datetime-value">
                            {detGurully?.ValidityFrom
                              ? GET_MONTH_YEAR(detGurully?.ValidityFrom)
                              : ""}
                          </span>
                        </div>
                      </div>

                      <div className="datetime-item">
                        <svg
                          className="datetime-icon"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                        >
                          <circle cx="12" cy="12" r="10"></circle>
                          <polyline points="12,6 12,12 16,14"></polyline>
                        </svg>
                        <div className="datetime-content">
                          <span className="datetime-label">Valid Till</span>
                          <span className="datetime-value">
                            {detGurully?.ValidityTill
                              ? GET_MONTH_YEAR(detGurully?.ValidityTill)
                              : ""}
                          </span>
                        </div>
                      </div>
                    </div>

                    <button
                      onClick={() =>
                        window.open("https://academy.testifyi.com", "_blank")
                      }
                      className="join-button"
                    >
                      <span>Start Practice</span>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                        <polyline points="15,3 21,3 21,9"></polyline>
                        <line x1="10" y1="14" x2="21" y2="3"></line>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            ) : TypeOfTest === "MockTest" && MockTestRec?.length ? (
              <>
                <section className="materials-header">
                  <div style={{ width: "100%" }}>
                    <select
                      className="mt"
                      onChange={(e) => {
                        // console.log("kl", ev?.target);
                        // setShowMore(ev?.target.value?.materialSubTitle);
                        setSelectDetails(e.target.value);
                        dispatch(mockTestDetails(e.target.value));
                      }}
                      style={{
                        width: "100%",
                        paddingRight: "10px",
                        height: "35px",
                      }}
                    >
                      {MockTestRec?.map((ev, i) => (
                        <option
                          value={ev?._id}
                          key={ev?._id}
                          style={
                            SelectDetails == ev?._id
                              ? { color: "#2C3F8C" }
                              : { color: "black" }
                          }
                        >
                          {ev?.MockNo}
                        </option>
                      ))}
                    </select>
                  </div>
                  {/* <div className="materials-tabs">
                    {MockTestRec?.map((ev, i) => (
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          setSelectDetails(ev?._id);
                          dispatch(mockTestDetails(ev?._id));
                        }}
                        key={766 + i}
                        className={
                          ev?._id == SelectDetails
                            ? "tab-btn active"
                            : "tab-btn"
                        }
                      >
                        {ev?.MockNo}
                      </button>
                    ))}
                  </div> */}
                </section>

                {/* <!-- Materials Content --> */}
                <section className="materials-content">
                  {/* <div className="materials-nav">
                    <div className="nav-item active">
                      <span>IELTS Introduction</span>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <polyline points="6,9 12,15 18,9" />
                      </svg>
                    </div>
                    <div className="nav-item">
                      <span>IELTS Introduction</span>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <polyline points="9,18 15,12 9,6" />
                      </svg>
                    </div>
                  </div> */}

                  <div className="material-detail">
                    <div className="material-text">
                      <div
                        className="DangeriousTextFrame2"
                        dangerouslySetInnerHTML={{
                          __html: mockDesc?.MockDescription,
                        }}
                      ></div>
                    </div>
                  </div>
                </section>
              </>
            ) : (
              <div style={{ padding: "20px" }}>
                <Lock />
              </div>
            )}
          </div>
          <MobileBottomMenu Page="Academy" />
        </div>
      </div>
    </>
  );
}
